import axios from "axios";
import SideBar from "./sidebar/ManagerSideBar";
import DashBoardNavbar from "./navbar/DashBoardNavbar";
// export default ProjectDetails;
import { styled } from '@mui/system';
import * as React from 'react';
import UploadManual from "../Modals/UploadManual";
import { useNavigate } from 'react-router';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import DragnDrop from "../../Utils/DragnDrop";
import AddIcon from "@mui/icons-material/Add";
import { Root1, CustomTablePagination1 } from "../../config/tableOptions";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "@material-ui/lab/Pagination";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import DeleteManualVideo from "../Modals/DeleteManualVideo";
import DeleteManualVideoMany from "../Modals/DeleteManualVideoMany";
import Spinner, { DotLoader } from "react-spinner-overlay";
import { ContactSupport } from "@mui/icons-material";
import TablePagination, {
  tablePaginationClasses as classes,

} from '@mui/base/TablePagination';


function UploadVideo() {
  const userType = sessionStorage.getItem("role") === "Deactivate";
  let navigate = useNavigate();
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [user, setuser] = React.useState("");
  const [modal4, setModal4] = React.useState(false);
  const [modal, setModal] =React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [deleteArray2, setDeleteArray2] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [modal3, setModal3] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [currentID, setCurrentID] = React.useState("");

  const [percentage, setPercentage] = React.useState("0");


  const logOut = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  const handleCheckboxChange = (id) => {
    if (deleteArray2.includes(id)) {
      const newArray = deleteArray2.filter((item) => item !== id);
      setDeleteArray2(newArray);
    } else {
      const tmpArr = [...deleteArray2, id];
      setDeleteArray2(tmpArr);
    }
  };



  const getData = async () => {
    setLoading(true);
    console.log("getting the videos")

    let data = await axios.get('/api/upload', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        console.log(response.data)
        setRows(response.data.reverse())
      })
      .catch(error => {
        // Handle error
        console.error(error);
      })

      .finally(() => {
        setLoading(false); // Set the loading state to false after the data is loaded or an error occurs
      });

  }


  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  React.useEffect(() => {
    console.log("inside socket use effect");
    const socket = new WebSocket("wss://feeds.playstream.media/websocket");
    // const socket = new WebSocket("ws://192.168.1.9:8004");
    // const socket = new WebSocket("ws://localhost:8004/websocket");


    socket.onopen = () => {
      console.log("WebSocket connected");
    };

    let data = 0;
    socket.onmessage = (event) => {
      let message = JSON.parse(event.data);
      if (message.type == 'video') {
        console.log(message)
        setPercentage(message.data);
        if (data == 100) {
          setTimeout(() => {
            getData();
            setPercentage(0);
          }, 2000);
        }
      }
    };

    return () => {
      socket.close();
    };
  }, []);

  const handlePageChange = (event, value) => {
    console.log(value);
    setPage(value);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  // const [page, setPage] = React.useState(1);
  const [count, setCount] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);

  const pageSizes = [5, 10, 25];

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   showSuccessToast(
  //     `Rows Per Page changed to ${parseInt(event.target.value, 10)}`
  //   );
  //   setPage(0);
  // };


  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // React.useEffect(() => {
  //   console.log("not in first ")
  //   getData();
  // }, [page, pageSize]);

  const [copied, setCopied] = React.useState(false);

  const handleCopy = (videoLink) => {
    navigator.clipboard.writeText(videoLink)
      .then(() => {
        setCopied(true);
        toast.success('Video link copied to clipboard!');
      })
      .catch((error) => {
        console.error('Error copying to clipboard:', error);
      });
  };
  // React.useEffect(() => {
  //   let timerId;

  //   const handleSearch = () => {
  //     getData();
  //   };

  //   const throttleSearch = () => {
  //     clearTimeout(timerId);

  //     timerId = setTimeout(handleSearch, 800);
  //   };

  //   throttleSearch(); // Initial search request

  //   return () => {
  //     clearTimeout(timerId); // Clean up the timer on component unmount
  //   };
  // }, [searchQuery]);

  const Root = Root1;
  const CustomTablePagination = CustomTablePagination1;

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
  };


  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    showSuccessToast(`Rows Per Page changed to ${parseInt(event.target.value, 10)}`)
    setPage(0);
  };

  React.useEffect(() => {
    getData()

  }, [])

  return (
    <body className={`overflow-hidden grad ${windowWidth <= 1200 ? "" : "g-sidenav-show"}`}>
      {/* side navbar */}
      {windowWidth >= 1200 && <SideBar />}
      <main className="main-content position-relative h-100 border-radius-lg">
        <DashBoardNavbar user={user} logOut={logOut} />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">
                      Manual Uploads
                    </h6>
                  </div>
                </div>
                <div className="card-body px-4 pb-2">
                  <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                    <Root sx={{ width: 1500, maxWidth: '100%' }}>
                      {loading ? (
                        <div class="d-flex justify-content-center m-3">
                          <DotLoader
                            visible={loading}
                            textContent={'Loading...'}
                            animation="grow"
                            overlayColor="rgba(0, 0, 0, 0.5)"
                            color="#5BC0F8"

                          />
                        </div>
                      ) : (
                        <table aria-label="custom pagination table">
                          <thead>

                               <tr>
                                 <th
                                  style={{ width: "5%" }}
                                  className="text-center"
                                >
                                  Sr No.
                                </th>
                                <th
                                  style={{ width: "25%" }}
                                  className="text-center"
                                >
                                  Name
                                </th>
                                {/* <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Video Title
                                </th> */}
                                {/* <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Duration
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Size
                                </th> */}
                                <th
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  Creation
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  HLS Path
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  MP4 Path
                                </th>
                                <th
                                  style={{ width: "20%" }}
                                  className="text-center"
                                >
                                  Action
                                </th>
                              </tr>
                        </thead>
                        <tbody>
                            {/* tempData */}
                          {
                            (rowsPerPage > 0
                              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : rows
                            )
                              .map((row, index) => (
                                <tr key={row._id}>
                                  <td>{index + 1}</td>
                                  <td>
                                      {row.name
                                        ? row.name
                                        : "No Title Found"}
                                    </td>
                                    {/* <td>
                                      {row.duration
                                        ? Math.floor(row.duration / 60) +
                                        " mins " +
                                        (row.duration % 60) +
                                        " sec"
                                        : "No Duration Found"}
                                    </td>
                                    <td>
                                      {row.size
                                        ? Math.round(row.size / (1024 * 1024)) +
                                        " MB"
                                        : "No Size Found"}
                                    </td> */}
                                    <td>
                                      {row.creation
                                        ? new Date(row.creation).toLocaleString()
                                        : "No Creation Found"}
                                    </td>
                                    <td className="text-center">
                                    {row.hlspath ? (
                                        <button
                                          style={{
                                            backgroundColor: "#F0F8FF",
                                            // #002D62
                                            color: "#034694",
                                            fontWeight: "bold",
                                            border: "2px",
                                            borderRadius: "7px",
                                            padding: "5%",
                                          }}
                                          onClick={() => handleCopy(row.hlspath)}
                                        >
                                          <i
                                            class="fa fa-clipboard"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Copy to Cliboard
                                        </button>
                                      ) : "No HLS File Found"
                                      }
                                    </td>

                                    <td className="text-center">
                                      {row.mp4path ? (
                                        <button
                                          style={{
                                            backgroundColor: "#F0F8FF",
                                            // #002D62
                                            color: "#034694",
                                            fontWeight: "bold",
                                            border: "2px",
                                            borderRadius: "7px",
                                            padding: "5%",
                                            textAlign: "center",
                                            align: "center"
                                          }}
                                          onClick={() => handleCopy(row.mp4path)}
                                        >
                                          <i
                                            class="fa fa-clipboard"
                                            aria-hidden="true"

                                          ></i>{" "}
                                          Copy to Cliboard
                                        </button>
                                      ) : "No MP4 File Found"}
                                    </td>

                                    <td className="bg-gray-200 ">
                                      {!userType && (
                                        <td
                                          className="bg-gray-200 text-center"
                                          style={{ width: "20%" }}
                                          align="right"
                                        >
                                          <button
                                            className="btn btn-link text-secondary mb-0"
                                            onClick={() => {
                                              setModal3(true);
                                              // deleteVideo(row._id);
                                              setCurrentID(row._id);
                                              console.log(row._id);
                                            }}
                                          >
                                            <DeleteIcon color="action" />
                                          </button>
                                          <button className="btn btn-link text-secondary mb-0"></button>
                                          {rows && (
                                            <button className="btn btn-link text-secondary mb-0">
                                              <input
                                                type="checkbox"
                                                checked={
                                                  deleteArray2.includes(
                                                    row._id
                                                  ) || false
                                                }
                                                onChange={() => {
                                                  handleCheckboxChange(row._id);
                                                  console.log(row._id);
                                                }}
                                              />
                                            </button>
                                          )}
                                        </td>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            {emptyRows > 0 && (
                              <tr style={{ height: 34 * emptyRows }}>
                                <td colSpan={3} />
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <CustomTablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={3}
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                slotProps={{
                                  select: {
                                    'aria-label': 'rows per page',
                                  },
                                  actions: {
                                    showFirstButton: true,
                                    showLastButton: true,
                                  },
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                              />
                            </tr>
                          </tfoot>

                        </table>
                      )}
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div
        style={{
          float: "right",
          marginRight: "20px",
          paddingTop: "15px",
        }}
      >

        <div
          className="fixed-bottom d-flex justify-content-end px-3"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: "10px"
          }}
        >
        {deleteArray2 && (
            <button
              className="btn btn-info  mr-4"
              onClick={() =>
                // deleteVideo()
                setModal(true)
              }
              style={{ float: "left" }}
            >
              <DeleteIcon /> Delete Many
            </button>
          )}
        <button
            className="btn btn-info"
            onClick={() => setModal4(!modal4)}
            style={{ float: "left" }}

          >
            <AddIcon /> Upload Video
          </button>


          <span
            className="d-sm-inline d-none"
            style={{ marginLeft: "5px" }}
          ></span>
        </div>
      </div>

      
      <UploadManual
        modal={modal4}
        setModal={setModal4}
        getData={getData}
      />
      <DeleteManualVideo
        // submit={submit}
        getData={getData}
        modal3={modal3}
        setModal3={setModal3}
        // deleteArray2={deleteArray2}
        currentID={currentID}
      />
      <DeleteManualVideoMany
        // submit={submit}
        getData={getData}
        modal={modal}
        setModal={setModal}
        deleteArray2={deleteArray2}
      // currentID={currentID}
      />
    </body >
  );
}

export default UploadVideo;